module.exports = __webpack_public_path__ + "static/media/slide_06.4dc73fe0.jpg";